import { Icon } from '../ui/Icon';
import { formatMoney } from '../../utils/costFormatting';
import { finalUnitAmount, formatPercent, priceText, type ProductDraft, type ProductStep } from '../../utils/newProduct';
import { ProductAnswerRow } from './ProductParts';
import { STEP_LOOK } from './ProductSteps';

// Rediseño · Bloque E — «Así quedará» (P-029), con B0-07: el protagonista es el importe que se cobra,
// con signo de pesos y grande; nunca «El cliente pagará». Con «Agregar impuestos» ese importe ya trae
// el porcentaje encima del precio capturado, y se dice de dónde sale. Ya creado, no se cambia nada.

export function ProductReview({ draft, storesLabel, costLabel, taxLabel, created, busy, onChange }: {
  draft: ProductDraft;
  storesLabel: string;
  /** P-071: «Sin definir por ahora», «Aproximadamente $X» o «Según receta». Nunca margen ni ganancia aquí. */
  costLabel: string;
  taxLabel: string;
  created: boolean;
  busy: boolean;
  onChange: (step: ProductStep) => void;
}) {
  const change = created ? undefined : (step: ProductStep) => () => onChange(step);
  const custom = draft.tax === 'CUSTOM';
  return (
    <section aria-labelledby="product-review-title" className="n3-product__review" tabIndex={-1}>
      <div className="n3-product__review-top">
        <span className="n3-product__kicker" id="product-review-title">
          <Icon name="sparkle" size={14} />
          <span>Así quedará</span>
        </span>
        <div className="n3-product__review-line">
          <p className="n3-product__review-name">{draft.name.trim()}</p>
          {change && <button aria-label="Cambiar nombre" className="n3-product__change" disabled={busy} onClick={change('name')} type="button">Cambiar</button>}
        </div>
        <div className="n3-product__review-line">
          <div className="n3-product__review-amount">
            <p className="n3-product__review-price">{formatMoney(String(finalUnitAmount(draft)))}</p>
            <p className="n3-product__review-caption">Precio al cobrar</p>
            {custom && <p className="n3-product__review-caption">{priceText(draft)} más {formatPercent(draft.taxPercent)} de impuestos</p>}
          </div>
          {change && <button aria-label="Cambiar precio" className="n3-product__change" disabled={busy} onClick={change('price')} type="button">Cambiar</button>}
        </div>
      </div>
      <div className="n3-product__review-rows">
        <ProductAnswerRow changeDisabled={busy} icon={STEP_LOOK.stores.icon} label={STEP_LOOK.stores.label} onChange={change?.('stores')} tone={STEP_LOOK.stores.tone} value={storesLabel} wrap />
        <ProductAnswerRow changeDisabled={busy} icon={STEP_LOOK.recipe.icon} label={STEP_LOOK.recipe.label} onChange={change?.('recipe')} tone={STEP_LOOK.recipe.tone} value={costLabel} wrap />
        <ProductAnswerRow changeDisabled={busy} icon={STEP_LOOK.tax.icon} label={STEP_LOOK.tax.label} onChange={change?.('tax')} tone={STEP_LOOK.tax.tone} value={taxLabel} wrap />
        {/* El servidor crea el producto activo: es lo que de verdad va a pasar, no una opción. */}
        <ProductAnswerRow icon="check" label="Estado" tone="success">
          <span className="n3-product__status"><Icon name="check" size={14} /><span>Disponible para vender</span></span>
        </ProductAnswerRow>
      </div>
    </section>
  );
}
